import React from 'react';

/* The app had no error boundary anywhere, so anything thrown during React's
 * commit phase tore down the entire root — that is the blank page users kept
 * reporting. This keeps the shell alive and captures the component stack, which
 * the minified production bundle otherwise throws away. */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    /* eslint-disable no-console */
    console.error('[ErrorBoundary]', this.props.label || 'app', error);
    console.error('[ErrorBoundary] component stack:', info && info.componentStack);
    /* eslint-enable no-console */
    window.__lastReactError = {
      at: new Date().toISOString(),
      url: window.location.href,
      label: this.props.label || 'app',
      message: error && error.message,
      stack: error && error.stack,
      componentStack: info && info.componentStack,
      domRecoveries: window.__domRecoveries,
    };
  }

  handleReset = () => this.setState({ error: null, info: null });

  handleCopy = () => {
    try {
      navigator.clipboard.writeText(JSON.stringify(window.__lastReactError, null, 2));
    } catch (_) { /* clipboard blocked — the console copy still works */ }
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="ev-alert-card-warning m-3 p-3">
        <div className="d-flex align-items-center mb-2">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <span className="ev-reg-p-dark fw-bold">Something broke while rendering this view.</span>
        </div>
        <div className="ev-small-p-dark mb-2">
          Your work is not lost. Reopen the tab to continue. If this keeps
          happening, click <b>Copy diagnostics</b> and send it to the team.
        </div>
        <details className="mb-2">
          <summary className="ev-fs-11 ev-reg-p-blue">Technical details</summary>
          <pre className="ev-fs-10 mt-2" style={{ whiteSpace: 'pre-wrap', maxHeight: 240, overflow: 'auto' }}>
            {String(this.state.error && this.state.error.message)}
            {this.state.info && this.state.info.componentStack}
          </pre>
        </details>
        <button type="button" className="ev-btn-blue-fill-round ev-bold-reg ev-btn-small me-2" onClick={this.handleReset}>
          Try again
        </button>
        <button type="button" className="ev-btn-blue-outline-round ev-bold-reg ev-btn-small" onClick={this.handleCopy}>
          Copy diagnostics
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
